import toast from 'react-hot-toast';

export const showToast = {
  success: (message: string) => {
    toast.success(message, {
      style: {
        background: '#1a1a1a',
        color: '#fff',
        border: '2px solid #4ade80',
        padding: '16px',
        fontSize: '1.1rem',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(74, 222, 128, 0.2)'
      },
      iconTheme: {
        primary: '#4ade80',
        secondary: '#1a1a1a'
      },
      duration: 6000
    });
  },
  error: (message: string) => {
    toast.error(message, {
      style: {
        background: '#1a1a1a',
        color: '#fff',
        border: '2px solid #ef4444',
        padding: '16px',
        fontSize: '1.1rem',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(239, 68, 68, 0.2)'
      },
      iconTheme: {
        primary: '#ef4444',
        secondary: '#1a1a1a'
      },
      duration: 6000
    });
  },
  loading: (message: string) => {
    return toast.loading(message, {
      style: {
        background: '#1a1a1a',
        color: '#fff',
        border: '2px solid #3b82f6',
        padding: '16px',
        fontSize: '1.1rem',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
      }
    });
  }
};

export default toast;